import axios from "axios";
import jwt from "jsonwebtoken";
import { throwInvalidLoginError } from "./errorFactory";

const OVERRIDE_CONFIG_URL = process.env.REACT_APP_OVERRIDE_CONFIG_URL;
const OVERRIDE_CANVAS_URL = process.env.REACT_APP_OVERRIDE_CANVAS_URL;

const configApiUrls = {
  au: OVERRIDE_CONFIG_URL || "https://config.bluedot.io/prod1",
  eu: OVERRIDE_CONFIG_URL || "https://eu1-config.bluedot.io/prod1",
  us: OVERRIDE_CONFIG_URL || "https://us1-config.bluedot.io/prod1",
};

export const canvasUrls = {
  au: OVERRIDE_CANVAS_URL || "https://canvas.bluedot.io/",
  eu: OVERRIDE_CANVAS_URL || "https://eu1-canvas.bluedot.io/",
  us: OVERRIDE_CANVAS_URL || "https://us1-canvas.bluedot.io/",
};

const getAuthorizationHeader = (accessToken) => {
  return {
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  };
};

export const login = async (email, password, region) => {
  try {
    const configUrl = configApiUrls[region];
    const loginResponse = await axios.post(`${configUrl}/sessions`, {
      email,
      password,
    });
    return loginResponse.data.accessToken;
  } catch (error) {
    if (error.message === "Network Error") {
      throwInvalidLoginError(
        "Login failed. Please check your network connection."
      );
    } else {
      throwInvalidLoginError(
        "Login failed. Please confirm your credentials and region."
      );
    }
  }
};

export const isUserAdmin = async (accessToken, region) => {
  const configUrl = configApiUrls[region];
  const userId = jwt.decode(accessToken).sub;
  const getUserUrl = `${configUrl}/users/${userId}`;
  const getUserResponse = await axios.get(
    getUserUrl,
    getAuthorizationHeader(accessToken)
  );
  if (!getUserResponse.data.isAdmin) {
    console.log("Non admin user request received: ", getUserResponse);
  }
  return getUserResponse.data.isAdmin;
};

export const getCanvasAccount = async (accessToken, region) => {
  const configUrl = configApiUrls[region];
  const getAccountUrl = `${configUrl}/accounts`;
  const getAccountResponse = await axios.get(
    getAccountUrl,
    getAuthorizationHeader(accessToken)
  );
  return getAccountResponse.data;
};

export const patchAccount = async (patchOperations, accessToken, region) => {
  const configUrl = configApiUrls[region];
  const getAccountUrl = `${configUrl}/accounts`;
  const patchAccountResponse = await axios.patch(
    getAccountUrl,
    patchOperations,
    getAuthorizationHeader(accessToken)
  );
  return patchAccountResponse;
};
